import { render } from "./CustomCarrierPercent.vue?vue&type=template&id=2ec899c6&scoped=true"
import script from "./CustomCarrierPercent.vue?vue&type=script&lang=js"
export * from "./CustomCarrierPercent.vue?vue&type=script&lang=js"

import "./CustomCarrierPercent.vue?vue&type=style&index=0&id=2ec899c6&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec899c6"]])

export default __exports__